var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChequeGreenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.8755 29.4566H8.76198C7.98156 29.4557 7.23337 29.1452 6.68153 28.5934C6.1297 28.0416 5.81927 27.2934 5.81836 26.5129V8.94373C5.81924 8.1633 6.12965 7.41508 6.68149 6.86322C7.23333 6.31135 7.98154 6.00091 8.76198 6H43.8755C44.656 6.00091 45.4042 6.31135 45.956 6.86322C46.5079 7.41508 46.8183 8.1633 46.8191 8.94373V26.5129C46.8183 27.2934 46.5078 28.0416 45.956 28.5934C45.4042 29.1453 44.656 29.4557 43.8755 29.4566Z",
    fill: "url(#paint0_linear_1653_4450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.8306 33.5021H4.71705C3.9367 33.5012 3.18856 33.1908 2.63674 32.6391C2.08491 32.0873 1.77445 31.3392 1.77344 30.5588V12.9896C1.77432 12.2092 2.08473 11.461 2.63657 10.9091C3.18841 10.3573 3.93662 10.0468 4.71705 10.0459H39.8306C40.611 10.0468 41.3593 10.3572 41.9111 10.9091C42.463 11.4609 42.7734 12.2092 42.7742 12.9896V30.5588C42.7732 31.3392 42.4628 32.0873 41.911 32.6391C41.3591 33.1909 40.611 33.5012 39.8306 33.5021Z",
    fill: "url(#paint1_linear_1653_4450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.2179 28.1475C20.946 28.1475 19.7027 27.7704 18.6452 27.0637C17.5876 26.3571 16.7634 25.3528 16.2766 24.1777C15.7899 23.0026 15.6625 21.7096 15.9107 20.4621C16.1588 19.2147 16.7713 18.0688 17.6707 17.1694C18.57 16.2701 19.7159 15.6576 20.9633 15.4095C22.2108 15.1613 23.5038 15.2887 24.6789 15.7754C25.854 16.2621 26.8583 17.0864 27.565 18.1439C28.2716 19.2015 28.6488 20.4448 28.6488 21.7167C28.6468 23.4217 27.9687 25.0563 26.7631 26.2619C25.5575 27.4675 23.9229 28.1456 22.2179 28.1475ZM22.2179 17.6665C21.4169 17.6665 20.6338 17.9041 19.9677 18.3491C19.3016 18.7942 18.7825 19.4268 18.4759 20.1669C18.1694 20.907 18.0892 21.7214 18.2455 22.5071C18.4017 23.2927 18.7875 24.0144 19.354 24.5809C19.9204 25.1473 20.6421 25.5331 21.4278 25.6893C22.2135 25.8456 23.0279 25.7654 23.768 25.4588C24.5081 25.1522 25.1407 24.6331 25.5857 23.967C26.0307 23.3009 26.2683 22.5178 26.2682 21.7167C26.267 20.6429 25.8399 19.6134 25.0806 18.8541C24.3213 18.0948 23.2918 17.6677 22.2179 17.6665Z",
    fill: "url(#paint2_linear_1653_4450)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1653_4450",
    x1: 47.6134,
    y1: 39.023,
    x2: 7.49698,
    y2: -1.09356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1653_4450",
    x1: 48.4104,
    y1: 47.9108,
    x2: 13.1125,
    y2: 12.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1653_4450",
    x1: 36.1995,
    y1: 35.6984,
    x2: 17.4711,
    y2: 16.9699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequeGreenImage);
export default __webpack_public_path__ + "static/media/ChequeGreenImage.58c8c2648f7493f9f04651f31b964714.svg";
export { ForwardRef as ReactComponent };